import { h } from "preact";
import { useLayoutEffect, useRef, useState } from "preact/hooks";
import { useSelector } from "react-redux";

import i18n from "../../i18n.js";
import { selectResult } from "../../store/salaryCalculatorStore.js";
import { incomeToK } from "../../salaryHelper.js";
import SalaryComparison from "./SalaryComparison.jsx";
import MonthlySalary from "./MonthlySalary.jsx";
import MonthlyExpenses from "./MonthlyExpenses.jsx";
import CostOfEmployment from "./CostOfEmployment.jsx";

export default function SalaryCalculatorResult({ type }) {
  const result = useSelector(selectResult);
  const ref = useRef(null);
  const [defaultRemoved, setDefaultRemoved] = useState(false);

  useLayoutEffect(() => {
    if (result && !defaultRemoved) {
      const siblings = ref.current.parentNode.children;
      Array.from(siblings).forEach((sibling) => {
        if (sibling !== ref.current) {
          sibling.parentNode.removeChild(sibling);
        }
      });
      setDefaultRemoved(true);
    }
  }, [result]);

  if (result == null) {
    return null;
  }

  return (
    <div ref={ref}>
      <section class="screenPadding__inner row mb-64">
        <div class="col s12 l6">
          <div class="salary-calculator-result">
            <p class="t-h3 t-h4--mobile color-brand-midnight">
              {i18n.t("pages.salary_calculator.result.title", {
                jobTitle: result.workRole,
              })}
            </p>

            <p class="t-body1 color-shades-charcoal">
              {i18n.t("pages.salary_calculator.result.line1")}
            </p>
            <p class="t-body1 color-shades-charcoal">
              {i18n.t("pages.salary_calculator.result.line2")}
            </p>

            <div class="salary-calculator-result__display-items">
              <div class="salary-calculator-result__display-item">
                <span class="salary-calculator-result__display-item-value">
                  <span class="salary-calculator-result__display-item-value-calc">
                    {incomeToK(result.grossIncome)}
                  </span>
                </span>
                <span class="salary-calculator-result__display-item-title">
                  {i18n.t("pages.salary_calculator.result.gross_income")}
                </span>
              </div>
              <div class="salary-calculator-result__display-item">
                <span class="salary-calculator-result__display-item-value">
                  <span class="salary-calculator-result__display-item-value-calc">
                    {incomeToK(result.netIncome)}
                  </span>
                </span>
                <span class="salary-calculator-result__display-item-title">
                  {i18n.t("pages.salary_calculator.result.net_income")}
                </span>
              </div>
            </div>
          </div>
        </div>

        <div class="col s12 l6 hide-on-med-and-down">
          {type == "payroll" ? (
            <img
              src="/images/pages/payroll_calculator/illu.jpg"
              alt="Female recruiter video chatting with candidate"
              style="max-height: 411px;"
              loading="lazy"
              data-reveal-on-view="animate__fadeInUpSlow"
            />
          ) : (
            <img
              src="/images/pages/salary_calculator/illu.jpg"
              alt="Young Indian engineer with a laptop calculating German salary"
              style="max-height: 411px;"
              loading="lazy"
              data-reveal-on-view="animate__fadeInUpSlow"
            />
          )}
        </div>
      </section>
      {type == "payroll" ? (
        <img
          src="/images/pages/payroll_calculator/illu.jpg"
          alt="Female recruiter video chatting with candidate"
          class="illustration hide-on-large-only"
          style="height: 411px;"
          loading="lazy"
          data-reveal-on-view="animate__fadeInUpSlow"
        />
      ) : (
        <img
          src="/images/pages/salary_calculator/illu_mobile.jpg"
          class="illustration hide-on-large-only"
          alt="Young Indian engineer with a laptop calculating German salary"
          style="height: 411px;"
          loading="lazy"
          data-reveal-on-view="animate__fadeInUpSlow"
        />
      )}

      <section class="screenPadding__inner row">
        <div class="col s12 l8 salary-calculator-result__block salary-calculator-result__block--bordered pt-48 mb-96">
          <SalaryComparison result={result} type={type} />
        </div>
      </section>

      {type === "payroll" && (
        <section class="screenPadding__inner row">
          <div class="col s12 l8 salary-calculator-result__block pt-48 mb-96">
            <CostOfEmployment result={result} />
          </div>
        </section>
      )}

      <section class="screenPadding__inner row">
        <div class="col s12 l8 salary-calculator-result__block mb-96">
          <MonthlySalary
            highlighted={type != "payroll"}
            result={result}
            type={type}
          />
        </div>
      </section>

      <section class="screenPadding__inner row mb-96">
        <div class="col s12 l8">
          <MonthlyExpenses result={result} />
        </div>
      </section>
    </div>
  );
}
